import ViewSharedUtil from "../ViewSharedUtil.js";

class ViewLocalStateProcessor {
  constructor(keyName) {
    this.keyName = keyName;
    this.statesToInclude = [
      "scroll",
      "subGrids",
      { name: "style", statesToInclude: ["flex"] }
    ];
  }


  processStateRetrieval(prevProcessedState, viewManager, viewType, initialDefaultState) {
    const processedState = {};
    const localStateKey = viewManager.renderState.selectedView.viewType;
    const localState = ViewSharedUtil.getFromLocalStorageForKey(localStateKey);
    if (localState && localState[viewType]) {
      const localStateForView = localState[viewType];
      this.statesToInclude.forEach((stateToInclude) => {
        if (typeof stateToInclude === "object") {
          if (localStateForView[stateToInclude.name]) {
            if (stateToInclude.name === "style") {
              processedState[stateToInclude.name] = ViewSharedUtil.mergeInlineStyleValueForLocalState(localStateForView, stateToInclude.statesToInclude, initialDefaultState);
            }
          } else {
            processedState[stateToInclude.name] = initialDefaultState[stateToInclude.name];
          }
        } else if (stateToInclude in localStateForView) {
          processedState[stateToInclude] = localStateForView[stateToInclude];
        }
      });
    }

    return { ...prevProcessedState, ...processedState };
  }

  processStateMutation(prevProcessedState, stateToUpdate, _initialDefaultState) {
    const processedState = {};

    this.statesToInclude.forEach((stateToInclude) => {
      if (typeof stateToInclude === "object" && stateToUpdate[stateToInclude.name]) {
        if (stateToInclude.name === "style") {
          processedState[stateToInclude.name] = ViewSharedUtil.getInlineStyleValueForLocalState(stateToUpdate, stateToInclude.statesToInclude);
        }
      } else if (stateToInclude in stateToUpdate) {
        processedState[stateToInclude] = stateToUpdate[stateToInclude];
      }
    });

    return { ...prevProcessedState, [this.keyName]: processedState };
  }
}

export default ViewLocalStateProcessor;
